module.exports = __webpack_public_path__ + "img/rauhorn.4bbef6e2.jpg";